import React from 'react';
import { WallData } from '../types/wall-data.type';

const WallContext = React.createContext<Partial<WallData>>({});

export default WallContext;
